import { render, staticRenderFns } from "./elqr.vue?vue&type=template&id=152cfdf0&"
import script from "./elqr.vue?vue&type=script&lang=js&"
export * from "./elqr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports